import {Component, Input, OnInit} from '@angular/core';
import {VnaCampaignPbxConfigService} from '../../services/vna-campaign-pbx-config.service';
import {ModalService} from 'ngx-dynamic-modal';
import {VnaCampaignPbxConfigEditComponent} from '../../modals/vna-campaign-pbx-config-edit/vna-campaign-pbx-config-edit.component';
import {PortalService} from '../../../vna_portal/model/PortalService';
import {AlertaService} from '../../../../../shared/services/alerta.service';
import {MessagingService} from '../../../../../core/service/messaging.service';
import {VnaPbxConfigRemoved} from '../../model/VnaPbxConfigRemoved';

@Component({
  selector: 'app-list-campaign-pbx-config',
  templateUrl: './list-campaign-pbx-config.component.html',
  styleUrls: ['./list-campaign-pbx-config.component.scss']
})
export class ListCampaignPbxConfigComponent implements OnInit {

    @Input() portalService: PortalService;
    loading: boolean = false;

    pbxConfigs: Array<Object> = [];

    constructor(private pbxConfigsService: VnaCampaignPbxConfigService, private modalService: ModalService, private alerts: AlertaService, private messaging: MessagingService) { }

    ngOnInit() {
        this.getPbxConfigs();
    }

    applyCallback(res: any): void {
        this.getPbxConfigs();
    }

    newPbxConfiguration(): void {
        this.modalService.addDynamicComponent(VnaCampaignPbxConfigEditComponent, {'camp' : this.portalService}, (res) => {
            this.applyCallback(res)
        });
    }

    editPbxConfigutation(row: Object): void {
        this.modalService.addDynamicComponent(VnaCampaignPbxConfigEditComponent, {'camp' : this.portalService, 'element' : row}, (res) => {
            this.applyCallback(res)
        });
    }

    clonePbxConfigutation(row: Object): void {
        this.modalService.addDynamicComponent(VnaCampaignPbxConfigEditComponent, {'camp' : this.portalService, 'element' : row, 'clone' : true}, (res) => {
            this.applyCallback(res)
        });
    }

    removePbxConfigutation(row: Object): void {

        this.loading = true;
        const pk = row['pk'];
        this.pbxConfigsService.removePbxConfig(row['service_campaign_pk'], row['pk']).subscribe(
            (result) => {
                const idx = this.pbxConfigs.findIndex((obj) => {
                    return obj['pk'] == row['pk'];
                });

                this.pbxConfigs.splice(idx, 1);
                if(result.hasOwnProperty('new_url_originate')){
                    this.messaging.sendMessage(new VnaPbxConfigRemoved(result['new_url_originate']));
                }

                this.loading = false;
                this.alerts.addAlert('success', 'Pabx config has been removed successfully');
            }
        )
    }

    getRowAction(row: Object): any {
        return (row['action_filename'].length > 0) ? row['action_filename'] : row['action_name'];
    }

    reloadPbxConfigs(): void {
        this.getPbxConfigs();
    }

    protected getPbxConfigs(): void {
        this.loading = true;
        this.pbxConfigsService.getPbxConfigs(this.portalService.pkCamp).subscribe(
            (result) => {
                this.pbxConfigs = result;
                this.loading = false;
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/components/list-campaign-pbx-config/list-campaign-pbx-config.component.ts